module.exports = __webpack_public_path__ + "static/img/image_home_product_02.ffd7e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_product_02.png
// module id = hK6F
// module chunks = 10